import React from 'react';
import { CSVLink } from 'react-csv';
import { Button } from '@material-ui/core';
import { removeIndex } from '#/removeIndex';

export const DownloadCSVButton = props => {
    const {
        data, filename, excludeColParams, style
    } = props;
    const dataToDownload = excludeColParams ? removeIndex(data, excludeColParams) : data;

    return (
        <Button style={style} variant='contained' color='primary'>
            <CSVLink data={dataToDownload ? dataToDownload : []} filename={filename} target='_blank' style={{ color: 'white' }}>
                Download CSV
            </CSVLink>
        </Button>
    );
};
